import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  Accordion,
  AccordionSet,
  Col,
  KeyValue,
  Row,
} from '@folio/stripes/components';

const SelfCheckoutDeviceDetail = ({ initialValues }) => {
  const device = initialValues || {};

  return (
    <AccordionSet>
      <Accordion
        label={
          <FormattedMessage id="ui-circulation.settings.selfCheckout.device.generalInfo" />
        }
        id="device-general-info"
      >
        <Row>
          <Col xs={6}>
            <KeyValue
              label={
                <FormattedMessage id="ui-circulation.settings.selfCheckout.device.libraryName" />
              }
              value={device.libraryName || '-'}
            />
          </Col>
          <Col xs={6}>
            <KeyValue
              label={
                <FormattedMessage id="ui-circulation.settings.selfCheckout.device.terminalLocation" />
              }
              value={device.terminalLocation || '-'}
            />
          </Col>
        </Row>
      </Accordion>

      <Accordion
        label={
          <FormattedMessage id="ui-circulation.settings.selfCheckout.device.settings" />
        }
        id="device-settings"
      >
        <Row>
          <Col xs={6}>
            <KeyValue
              label={
                <FormattedMessage id="ui-circulation.settings.selfCheckout.device.timeoutPeriod" />
              }
              value={device.timeoutPeriod || 0}
            />
          </Col>
          <Col xs={6}>
            <KeyValue
              label={
                <FormattedMessage id="ui-circulation.settings.selfCheckout.device.retriesAllowed" />
              }
              value={device.retriesAllowed || 0}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={4}>
            <KeyValue
              label={
                <FormattedMessage id="ui-circulation.settings.selfCheckout.device.checkinOk" />
              }
              value={device.checkinOk ? 'Yes' : 'No'}
            />
          </Col>
          <Col xs={4}>
            <KeyValue
              label={
                <FormattedMessage id="ui-circulation.settings.selfCheckout.device.checkoutOk" />
              }
              value={device.checkoutOk ? 'Yes' : 'No'}
            />
          </Col>
          <Col xs={4}>
            <KeyValue
              label={
                <FormattedMessage id="ui-circulation.settings.selfCheckout.device.acsRenewalPolicy" />
              }
              value={device.acsRenewalPolicy ? 'Yes' : 'No'}
            />
          </Col>
        </Row>
      </Accordion>
    </AccordionSet>
  );
};

SelfCheckoutDeviceDetail.propTypes = {
  initialValues: PropTypes.object,
};

export default SelfCheckoutDeviceDetail;
